<template>
  <ul class="i-repeat">
    <template v-for="(item, index) in items">
      <li
        v-if="!item.hidden"
        :id="item?.id"
        :key="index"
        class="i-repeat-li"
        :class="`${liClass}`"
      >
        <slot :item="item" />
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'IRepeat',
  props: {
    liClass: {
      type: String,
      default () {
        return ''
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/common/extends'

.i-repeat-li {
  display: flex
  align-items: center
}

.i-repeat-a {
  @extend .full
  @extend .btn-no-default
  padding: 0
  position: relative
  display: flex
  align-items: center
  pointer-events: auto
}

</style>
